"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var React = require("react");
var util_1 = require("~/js/lib/util/util");
var theme_1 = require("~@/widget/theme/theme");
var then_ajax_1 = require("then-ajax");
var stat_1 = require("~@/widget/stat/stat");
require("./search-auto-complete.scss");
var CHANNEL_LIMIT = 1;
var SORT_LIMIT = 1;
var COL_LIMIT = 8;
var INTERFACE = {
    THINK_WORD: theme_1.DOMAIN + "/search/search2.json?t=-3&n=1&s=10"
};
var searchCache = {};
var SearchAutoComplete = (function (_super) {
    __extends(SearchAutoComplete, _super);
    function SearchAutoComplete(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            channelDatas: [],
            sortDatas: [],
            currentIndex: -1,
            colDatas: [],
            result: false
        };
        _this.fetchKeyword = util_1.debounce(function (str) { return __awaiter(_this, void 0, void 0, function () {
            var json, response, colDatas_1, sortDatas_1, channelDatas_1, docs, docs, docs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!str) return [3, 1];
                        this.clear();
                        return [3, 3];
                    case 1: return [4, then_ajax_1.thenGet(INTERFACE.THINK_WORD, { q: str })];
                    case 2:
                        json = _a.sent();
                        if (json &&
                            json.data &&
                            json.data.searchResult) {
                            response = json.data.searchResult.response;
                            if (response[-10086]) {
                                return [2, this.clear()];
                            }
                            colDatas_1 = [];
                            sortDatas_1 = [];
                            channelDatas_1 = [];
                            if (response[2]) {
                                docs = response[2].docs;
                                if (docs && docs.length) {
                                    docs.slice(0, CHANNEL_LIMIT).forEach(function (d) {
                                        var sid = d.sid, ssid = d.ssid, iconUrl = d.iconUrl, asid = d.asid, liveOn = d.liveOn, name = d.name, dataType = d.dataType;
                                        var url = "/" + sid;
                                        if (ssid) {
                                            url = url + "/" + ssid;
                                        }
                                        if (dataType === 3) {
                                            url = "/love" + url;
                                        }
                                        url = theme_1.DOMAIN + "/" + url;
                                        channelDatas_1.push({
                                            sid: sid,
                                            ssid: ssid,
                                            iconUrl: util_1.convertHttps(iconUrl),
                                            asid: asid,
                                            liveOn: liveOn,
                                            name: name,
                                            url: url
                                        });
                                    });
                                }
                            }
                            if (response[121]) {
                                docs = response[121].docs;
                                if (docs && docs.length) {
                                    docs.slice(0, SORT_LIMIT).forEach(function (d) {
                                        sortDatas_1.push(d);
                                    });
                                }
                            }
                            if (response[-3]) {
                                docs = response[-3].docs;
                                if (docs && docs.length) {
                                    docs.slice(0, COL_LIMIT).forEach(function (d) {
                                        var sid = d.sid, subid = d.subid, liveOn = d.liveOn, key = d.key;
                                        var url = '';
                                        if (liveOn === '1' && sid) {
                                            url = "//www.yy.com/" + sid;
                                            if (subid) {
                                                url = url + "/" + subid;
                                            }
                                        }
                                        colDatas_1.push({
                                            sid: sid,
                                            subid: subid,
                                            liveOn: liveOn,
                                            key: key,
                                            url: url
                                        });
                                    });
                                }
                            }
                            this.setState({
                                colDatas: colDatas_1,
                                sortDatas: sortDatas_1,
                                channelDatas: channelDatas_1,
                                result: colDatas_1.length || sortDatas_1.length || channelDatas_1.length ? true : false,
                                currentIndex: -1
                            });
                        }
                        _a.label = 3;
                    case 3: return [2];
                }
            });
        }); }, 300);
        return _this;
    }
    SearchAutoComplete.prototype.render = function () {
        var _this = this;
        var _a = this.state, channelDatas = _a.channelDatas, sortDatas = _a.sortDatas, colDatas = _a.colDatas, currentIndex = _a.currentIndex, result = _a.result;
        var _b = this.props, enablePopup = _b.enablePopup, val = _b.val;
        var hightlight = function (str) {
            var splits = str.split(val);
            if (splits.length > 1) {
                return splits.map(function (t, index) {
                    return (React.createElement(React.Fragment, { key: index },
                        t,
                        index !== splits.length - 1 && (React.createElement("span", { className: "search-hightlight" }, val))));
                });
            }
            else {
                return (React.createElement(React.Fragment, null, str));
            }
        };
        return (React.createElement("div", { className: "p-header__drag p-header__drag--think " + (enablePopup && result ? 'p-header__drag--show' : '') },
            React.createElement("span", { className: "p-header__drag__enterstage" },
                React.createElement("i", { className: "p-header__drag__enterstage__tri" }),
                React.createElement("i", { className: "p-header__drag__enterstage__tri2" })),
            React.createElement("div", { className: "p-header__drag__main" },
                React.createElement("ul", { className: "p-header-search__mod-think" },
                    channelDatas.map(function (item, index) {
                        return (React.createElement("li", { className: "p-header-search__mod-think__item p-header-search__mod-think__channelbox " + (currentIndex === index ? 'p-header-search__mod-think__item--hover' : ''), key: index },
                            React.createElement("a", { className: "p-header-search__mod-think__channelbox__main", href: item.url, target: "_blank", onClick: function () { return stat_1.stat(stat_1.EStatType.SEARCH_CHANNEL_BOX_ITEM_CLICK, [item.asid]); } },
                                React.createElement("div", { className: "p-header-search__mod-think__channelbox__main__avatar", style: { backgroundImage: "" + (item.iconUrl ? "url(" + item.iconUrl + ")" : '') } }),
                                React.createElement("div", { className: "p-header-search__mod-think__channelbox__main__tips" },
                                    React.createElement("h2", { className: "p-header-search__mod-think__channelbox__main__tl" }, hightlight(item.name)),
                                    React.createElement("div", { className: "p-header-search__mod-think__channelbox__main__info" },
                                        React.createElement("span", { className: "p-header-search__mod-think__channelbox__main__info__id" },
                                            "ID:",
                                            item.asid),
                                        item.liveOn === '1' && (React.createElement("span", { className: "p-header-search__mod-think__channelbox__main__info__status p-header-search__mod-think__channelbox__main__info__status--live" }, "\u76F4\u64AD\u4E2D")),
                                        item.liveOn !== '1' && (React.createElement("span", { className: "p-header-search__mod-think__channelbox__main__info__status", onClick: function () { return stat_1.stat(stat_1.EStatType.SEARCH_LIVE_BTN_CLICK); } }, "\u8FDB\u5165\u76F4\u64AD\u95F4")))))));
                    }),
                    sortDatas.map(function (item, index) {
                        return (React.createElement("li", { className: "p-header-search__mod-think__item p-header-search__mod-think__sortbox " + (currentIndex === channelDatas.length + index ? 'p-header-search__mod-think__item--hover' : ''), key: index },
                            React.createElement("a", { className: "p-header-search__mod-think__sortbox__main", href: item.url, target: "_blank", onClick: function () { return stat_1.stat(stat_1.EStatType.SEARCH_SORT_BOX_ITEM_CLICK, [item.word]); } },
                                "\u67E5\u770B\u6240\u6709",
                                React.createElement("span", { className: "p-header-search__mod-think__sortbox__main__light" }, hightlight(item.word)),
                                "\u76F4\u64AD")));
                    }),
                    colDatas.map(function (item, index) {
                        return (React.createElement("li", { className: "p-header-search__mod-think__item p-header-search__mod-think__connectbox " + (currentIndex === channelDatas.length + sortDatas.length + index ? 'p-header-search__mod-think__item--hover' : ''), key: index, onClick: function () { return _this.props.search(item.key); } },
                            hightlight(item.key),
                            item.liveOn === '1' && (React.createElement("a", { className: "p-header-search__mod-think__connectbox__live", href: item.url, target: "_blank", onClick: function () { return stat_1.stat(stat_1.EStatType.SEARCH_LIVE_BTN_CLICK); } }))));
                    })))));
    };
    SearchAutoComplete.prototype.clear = function () {
        this.setState({
            channelDatas: [],
            sortDatas: [],
            currentIndex: -1,
            colDatas: [],
            result: false
        });
    };
    SearchAutoComplete.prototype.changeCurrent = function (offset) {
        var _a = this.state, currentIndex = _a.currentIndex, channelDatas = _a.channelDatas, sortDatas = _a.sortDatas, colDatas = _a.colDatas;
        var setKeyword = this.props.setKeyword;
        var length = channelDatas.length + sortDatas.length + colDatas.length;
        if (length === 0) {
            return;
        }
        var nextIndex = (currentIndex + offset) % length;
        if (currentIndex === -1 && offset < 0) {
            nextIndex += 1;
        }
        if (nextIndex < 0) {
            nextIndex = length + nextIndex;
        }
        var keywords = [];
        channelDatas.forEach(function (item) {
            keywords.push(item.asid);
        });
        sortDatas.forEach(function (item) {
            keywords.push(item.word);
        });
        colDatas.forEach(function (item) {
            keywords.push(item.key);
        });
        var curTxt = keywords[nextIndex];
        this.setState({
            currentIndex: nextIndex
        });
        setKeyword(curTxt);
    };
    return SearchAutoComplete;
}(React.Component));
exports.SearchAutoComplete = SearchAutoComplete;
